// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"76cd1a93","422":"874e24df"}[chunkId] + ".chunk.js";
};